import { AuditLogsAxiosInstance } from "../Network/Auditlogs";

export const getAuditLogs = async (
  params: {
    page?: number;
    limit?: number;
    companyId?: string;
    targetType?: string;
    action?: string;
    actorId?: string;
  }
) => {
  const { data } = await AuditLogsAxiosInstance.get("audit-logs", { params });
  return data;
};


export const getLastAuditLog = async (params: {
  companyId?: string;
  targetType: string;
  targetId: string;
}) => {
  const { data } = await AuditLogsAxiosInstance.get("audit-logs/last", { params });
  return data; 
};

export interface AuditLogItem {
  id: string;
  actorName: string;
  actorId: string;
  actorRole: string;
  targetType: string;
  targetLabel: string;
  targetId: string;
  action: string;
  eventDescription: string;
  updatedArea: string;
  entityName: string;
  relationName: string | null;
  changedFields: Record<string, { old: unknown; new: unknown }> | null;
  companyId: string;
  createdAt: string;
}

export enum AuditAction {
  CREATE       = "CREATE",
  UPDATE       = "UPDATE",
  SOFT_DELETE  = "SOFT_DELETE",
  RESTORE      = "RESTORE",
  HARD_DELETE  = "HARD_DELETE",
  ACTIVATE     = "ACTIVATE",
  DEACTIVATE   = "DEACTIVATE",
}